import { render } from "./static-welcome-search.vue?vue&type=template&id=7b3702c0"
import script from "./static-welcome-search.js?vue&type=script&lang=js"
export * from "./static-welcome-search.js?vue&type=script&lang=js"

import "./static-welcome-search.vue?vue&type=style&index=0&id=7b3702c0&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__